<div class="row">
    <div class="col-12">
        <mat-card appearance="outlined" class="mt-4">
            <div [formGroup]="formGroup" class="d-flex flex-column">
                <span>Sélectionner un autre centre :</span>
                <div class="d-flex flex-row align-items-center">
                    <mat-form-field class="col-4 pr-0">
                        <input #autoCompleteInput [formGroup]="formGroup" [matAutocomplete]="centre" autocomplete="off"
                               class="px-2 justify-content-center align-items-start" formControlName="place" matInput>
                        <mat-autocomplete #centre="matAutocomplete">
                            <mat-option *ngFor="let item of filteredPlace | async"
                                        [value]="item.place.name">{{item.place.name}}</mat-option>
                        </mat-autocomplete>
                    </mat-form-field>
                    <mat-icon (click)="openModal()" class="col-1 px-0 mx-0">place</mat-icon>
                </div>
            </div>

            <mat-accordion class="young-register-event">
                <mat-expansion-panel>
                    <mat-expansion-panel-header>
                        <mat-panel-title>Sélectionnez une activité</mat-panel-title>
                    </mat-expansion-panel-header>
                    <div>
                        <app-grid-event-multi-select (selectionChange)="onSelectionChange($event)"
                                                     [defaultSelection]="defaultSelection"
                                                     [eventList]="eventList"></app-grid-event-multi-select>
                    </div>
                </mat-expansion-panel>
            </mat-accordion>

            <button (click)="onRemovePlace()" class="mt-4" mat-button>Supprimer ce centre
                <mat-icon>delete</mat-icon>
            </button>

        </mat-card>
    </div>
</div>
